<template>
  <div class="wrapper-sidebar-availability">
    <h2>{{ $t(`${base}.title`, { name: exExperience.name }) }}</h2>
    <p v-html="$t(`${base}.description`)"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LadSidebarAvailability',
  data() {
    return {
      base: 'experience.sidebars.availability',
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        name: state.experience.name,
      }),
    }),
  },
}
</script>

<style lang="scss">
.wrapper-sidebar-availability {
  padding-right: 15px;
}
</style>
